export const testimonials = [
  {
    name: "Sona Arjun",
    role: "Satisfied Customer",
    rating: 5,
    comment:
      "Best Salon in Payyoli! Had a great experience — the staff are very friendly, helpful, and offer honest suggestions. The hair specialist Mehfooz is extremely skilled and knowledgeable. I got a haircut and hair color done, and absolutely loved the result! The salon is well-equipped, comfortable, and has a great atmosphere. Highly recommended for anyone looking for quality service!",
    image: null,
  },
  {
    name: "Sreelekha Sathyan",
    role: "Happy Client",
    rating: 5,
    comment:
      "Myos is one of the best beauty parlour in payyoli. Their customer service and quality are excellent. I'm personally mentioning one of their staff Ms. Sathya. She was very patient and also has good behaviour towards the client. I really loved their services.",
    image: null,
  },
  {
    name: "Ruksana M",
    role: "Delighted Customer",
    rating: 5,
    comment:
      "I had an absolutely wonderful experience at Myos Makeover! From the moment I walked in, the ambiance was warm, elegant, and inviting. But what truly made my visit exceptional was the outstanding customer service provided by Mehfooj. The team was incredibly attentive, professional, and kind throughout my entire appointment. Mehfooj took the time to understand exactly what I wanted, gave honest suggestions, and delivered results that far exceeded my expectations. His attention to detail and gentle approach made me feel completely at ease.",
    image: null,
  },
  {
    name: "Adiyalakshmi R",
    role: "Satisfied Client",
    rating: 5,
    comment:
      "Went for a haircut there and was the best one in my life. I loved the way they treat the clients. Whole time it was so comfortable. Everything went so nice and smooth and the final look was just perfect. Must try them!🤌💗",
    image: null,
  },
  {
    name: "Muhammad Nasar",
    role: "Happy Customer",
    rating: 5,
    comment:
      "Excellent facilities and service. I had a great experience at the saloon. Your professionals truly set you special. Keep up the amazing work!",
    image: null,
  },
  {
    name: "Annaah",
    role: "Satisfied Client",
    rating: 5,
    comment:
      "An amazing job that exceeds all expectations! I am very glad that I trusted you. The service was provided efficiently, professionally and quickly. I will recommend you to my friends.",
    image: null,
  },
  {
    name: "Jyothi Rajeev",
    role: "Delighted Customer",
    rating: 5,
    comment:
      "Went for a butterfly haircut, left absolutely stunning. The customer service was immaculate, the care for details was very much obvious, they do also comment what you must do to maintain your hairstyle which I find absolutely necessary. Overall I highly recommend this place and will be visiting next time I need a haircut.",
    image: null,
  },
];
